module.exports = __webpack_public_path__ + "img/xindai_step2_yixin.4565ac64.png";